<template>
  <TableGradient
      icon-name="broadcast-tower"
      title="Listagem de Faixa de Resultado"
      text-empty="Nenhuma faixa de resultado encontrada"
      route-new="resultrange.create"
      text-new="Criar Faixa de Resultado"
      :fields="fields"
      :items="resultranges"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('resultrange/listAll', evt)"
      table-data
      disable-filters
  >
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'resultrange.edit', params: { id: linha.item.mapping_result_range_id }}"
                   class="font-weight-bold">
                   Editar
      </router-link>
    </template>
    
    <template v-slot:cell(mapping_result_range_status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.mapping_result_range_status, 'badge badge-danger': !linha.item.mapping_result_range_status}">
          <i :class="linha.item.mapping_result_range_status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      resultranges: 'dexpara/resultrange/all',
      paginator: 'dexpara/resultrange/pagination',
      store_isLoading: 'dexpara/resultrange/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'vns_integration_origin_name', label: 'Origem'},
        {key: 'vns_integration_destination_name', label: 'Destino'},
        {key: 'tuevs_exam_name', label: 'Exame'},
        {key: 'mapping_result_range_status', label: 'Status'},
        {key: 'id', label: 'Editar'}
      ]
    }
  },
  methods: {
    ...mapActions([
      'dexpara/resultrange/listAll'
    ])
  },
  mounted() {
    this['dexpara/resultrange/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style scoped>
</style>